module.exports = __webpack_public_path__ + "img/Picture15.6eb1d746.jpg";